<template>
    <div>
        <table>
            <tr>
                <td>
                    Duration
                </td>
                <td>
                    <vue-numeric
                        thousand-separator="'"
                        :min="1"
                        :max="3600"
                        currency="s"
                        currency-symbol-position="suffix"
                        v-model="settings.time"
                    />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>
    </div>

</template>

<script>
import actionMixin from './action.mixin';

export default {
    mixins: [actionMixin],
    methods: {
    },
    props: [
    ],
    data: function(){return{
        
    }},
    beforeMount: function(){
        Vue.set(this.settings, 'inputTypes', ['ExSample','MiniSample']);
        //Vue.set(this.settings, 'outputType', 'SnapvialSample');
        
        this.setDefault('time', 1); 

        
    }
}

</script>

<style>
    
</style>

<style lang="scss" src="./action.scss" scoped>